import { render } from "./PixKeyRemovalConfirmationDialog.vue?vue&type=template&id=d1c6a316"
import script from "./PixKeyRemovalConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./PixKeyRemovalConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__